<template>
  <div class="no-data">
    <img
      src="@assets/invisible.png"
      alt="No Data"
    />
    <span>
      {{ $t('vulInfo.noData') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'NoData',
};
</script>

<style lang="scss" scoped>
.no-data {
  position: relative;
  margin: 16px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 400px;
  font-size: 20px;
  background-color: #000;
  color: #fff;
  border-radius: 6px;
  padding: 20px;

  img {
    margin-top: 50px;
    width: 100px;
    height: 100px;
  }

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #fff;
  }
}

.is-mobile .no-data {
  height: 220px;

  img {
    margin-top: 20px;
    width: 60px;
    height: 60px;
  }

  span {
    font-size: 14px;
    text-align: center;
  }
}
</style>
